
import React from 'react'
import { Button } from 'primereact/button'
import { CinemaNews } from '../../api/movies'
import { useTranslation } from 'react-i18next'

interface NewsCardProps {
    item: CinemaNews
}

const NewsCard: React.FC<NewsCardProps> = ({ item }) => {
    const { i18n } = useTranslation()

    const getNewsTitle = (newsItem: CinemaNews) => {
        return i18n.language === 'ta' ? newsItem.titleTamil : i18n.language === 'de' ? newsItem.titleGerman : newsItem.title
    }

    const getNewsSummary = (newsItem: CinemaNews) => {
        return i18n.language === 'ta' ? newsItem.summaryTamil : i18n.language === 'de' ? newsItem.summaryGerman : newsItem.summary
    }

    const header = (
        <img alt={getNewsTitle(item)} src={item.imageUrl} style={{ height: '220px', objectFit: 'cover' }} className="w-full" />
    );

    return (
        <div className="col-12 md:col-6 lg:col-4 p-3">
            <div className="h-full shadow-4 hover:shadow-6 border-round-xl cursor-pointer bg-gray-900 border-1 border-gray-800 overflow-hidden flex flex-column">
                {header}
                <div className="p-3 flex flex-column flex-grow-1">
                    <div className="flex align-items-center gap-2 mb-2 text-gray-400 text-sm">
                        <i className="pi pi-calendar text-orange-500"></i>
                        <span>{item.publishDate}</span>
                    </div>
                    <div className="text-lg font-bold mb-2 text-white line-height-3">{getNewsTitle(item)}</div>
                    <p className="text-gray-400 line-height-3 mb-4 text-sm flex-grow-1">
                        {getNewsSummary(item)}
                    </p>
                    <Button label="Read More" icon="pi pi-arrow-right" className="p-button-text pl-0 text-orange-500 hover:text-orange-400 font-bold align-self-start mt-auto" />
                </div>
            </div>
        </div>
    )
}

export default NewsCard
